<template>
  <div>
    <div v-if="inReview" class="alert alert-warning d-flex align-items-center gap-2 mb-3" role="status">
      <Icon icon="fa-pro-solid:hourglass-half" />
      <span>{{ reviewHint }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
import {OBJECT_REVIEW_HINT} from '@/utils/objectReview'

export default {
  props: {
    inReview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviewHint() {
      return OBJECT_REVIEW_HINT
    },
  },
}
</script>
